import { render, staticRenderFns } from "./factory_performance.vue?vue&type=template&id=f377a1aa&"
import script from "./factory_performance.vue?vue&type=script&lang=js&"
export * from "./factory_performance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports